import isValid from 'date-fns/isValid'

export default function date() {
  return this.test('date', 'dateInvalid', (value) =>
    value ? isValid(value) : false,
  )
}
